/* Mouth Tape PDP sections: reveal-on-scroll + tap-to-play customer videos.
   Loaded by several sections; the guard keeps it to one run per page and the
   init() call re-runs safely when the theme editor re-renders a section. */
(function () {
  if (window.__mtpInit) { window.__mtpInit(); return; }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 }) : null;

  function initReveal(root) {
    if (!io || reduce) return;
    root.querySelectorAll('[data-mtp-reveal]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (el, i) {
        if (el.classList.contains('mtp-rv')) return;
        el.classList.add('mtp-rv');
        el.style.transitionDelay = (i % 5) * 90 + 'ms';
        io.observe(el);
      });
    });
  }

  function initVideos(root) {
    root.querySelectorAll('[data-mtp-ugc]').forEach(function (list) {
      if (list.dataset.mtpReady) return;
      list.dataset.mtpReady = '1';
      var tiles = Array.prototype.slice.call(list.querySelectorAll('.mtp-vid'));
      tiles.forEach(function (tile) {
        var v = tile.querySelector('video');
        if (!v) return;
        tile.addEventListener('click', function () {
          var playing = !v.paused;
          tiles.forEach(function (t) {
            var o = t.querySelector('video');
            if (o) o.pause();
            t.classList.remove('is-on');
          });
          if (playing) return;
          if (!v.getAttribute('src')) v.setAttribute('src', v.dataset.src);
          v.muted = false;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
          tile.classList.add('is-on', 'is-started');
        });
        v.addEventListener('ended', function () { tile.classList.remove('is-on'); });
      });
    });
  }

  window.__mtpInit = function () { initReveal(document); initVideos(document); };
  window.__mtpInit();
  document.addEventListener('shopify:section:load', window.__mtpInit);
})();
